import type { Product } from '@libs/common-next';
import { Currency, Locale, getLocale } from '@libs/core';
import type { EventTracking } from '../types';

export const dataLayerPush = (props?: EventTracking) => {
    if (props?.uniqueEventId) {
        return;
    }

    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    if (props) {
        window.dataLayer.push(props);
    }
};

export type Item = {
    item_name: string;
    item_id: string;
    price?: number;
    index: number;
    item_category?: string;
    item_category2?: string;
    item_category3?: string;
    item_category4?: string;
    item_category5?: string;
    item_brand?: string;
    item_variant?: string;
    item_list_name?: string;
    item_list_id?: string;
    item_search_term?: string;
};

const createItems = (products: Product[], listName: string, listId: string, searchTerm = '') => {
    const items: Item[] = [];

    products.forEach((product: Product, i: number) => {
        items.push({
            item_name: product.title ?? '',
            item_id: product.masterProductID?.toString() ?? '',
            price: product.prices ? parseFloat(product.prices[product.prices.length - 1].toString()) : undefined,
            index: product.__position ?? i + 1,
            item_category: product.merchandisingHierarchy?.vicePresidentName ?? '',
            item_category2: product.merchandisingHierarchy?.division ?? '',
            item_category3: product.merchandisingHierarchy?.department ?? '',
            item_category4: product.merchandisingHierarchy?.class ?? '',
            item_category5: product.merchandisingHierarchy?.category ?? '',
            item_brand: product.brand,
            item_variant: `${product.id}`,
            item_list_name: listName,
            item_list_id: listId,
            item_search_term: searchTerm,
        });
    });

    return items;
};

export const createItemsViewEvent = (
    products: Product[],
    listName: string,
    listId: string,
    filteredCategories: string[] = [],
    searchTerm = ''
) => {
    const items: Item[] = createItems(products, listName, listId, searchTerm);
    const locale = getLocale();
    const currency = locale === Locale['en-US'] ? Currency.USD : Currency.CAD;

    return {
        ecommerce: {
            currency,
            category: filteredCategories[0] ?? '',
            sub_category1: filteredCategories[1] ?? '',
            sub_category2: filteredCategories[2] ?? '',
            items,
        },
    };
};
